export const contextMain = {
    title: "Remplissage de vos informations",
    complete: "compléter",
    legends: {
        user: "Utilisateur",
        offices: "Cabinet | Cabinet | Cabinets"
    },
    'user-title': {
        title: "Titre",
        description: "Renseignez votre titre décrivant au mieux votre profession",
        'link-title': "Renseignez votre titre complet"
    },
    organizations: {
        title: "Associations",
        description: "Renseignez les différentes associations avec lesquelles vous avez pu travailler",
        'link-title': "Ajoutez vos différentes associations"
    },
    formations: {
        title: "Formations",
        description: "Indiquez les différentes formations que vous avez suivies",
        'link-title': "Ajoutez vos différentes formations"
    },
    naf: {
        title: "Code NAF",
        description: "Requis pour activer le Tax Report DGFiP",
        'link-title': "Renseignez votre code NAF / APE"
    },
    'nom-societe': {
        title: "Nom de la société",
        description: "Obligatoire pour la facturation électronique",
        'link-title': "Renseignez le nom de votre société"
    },
    'adresse-societe': {
        title: "Adresse société",
        description: "Obligatoire pour la facturation électronique",
        'link-title': "Renseignez l'adresse de votre société"
    },
    avatar: {
        title: "Avatar",
        description: "Modifiez votre avatar pour personnaliser votre page",
        'link-title': "Modifiez votre avarar"
    }
}